{
    "NAME": "LogManagementListLanguage",
    "LogManagementList_Column_Name": "Protokolldatei",
    "LogManagementList_Column_ClassName": "Für die Klasse",
    "LogManagementList_Column_FileName": "Dateiname",
    "LogManagementList_Column_FileSize": "Dateigröße",
    "LogManagementList_Column_Status": "Status",
    "LogManagementList_Status_Running": "Läuft",
    "LogManagementList_Status_NotRunning": "Läuft nicht",
    "LogManagementList_Action_Start": "Start",
    "LogManagementList_Action_Stop": "Stoppen",
    "LogManagementList_Action_Reset": "Zurücksetzen",
    "LogManagementList_Action_Download": "Herunterladen",
    "LogManagementList_SearchPlaceholder": "[Protokolldatei]",
    "LogManagementList_Empty": "Es werden derzeit keine Protokolleinträge angezeigt, was wahrscheinlich auf ein kritisches Initialisierungsproblem der Anwendung oder einer internen Komponente hinweist.",
    "LogManagementList_Confirm_ResetTitle": "Protokolldateien zurücksetzen",
    "LogManagementList_Confirm_ResetBody": "Warnung: Wenn Sie die Option zum Zurücksetzen von Protokolldateieinträgen wählen, werden die entsprechenden Dateien gelöscht. Dieser Vorgang ist nicht rückgängig zu machen.",
    "LogManagementList_Confirm_StopTitle": "Protokollierung beenden",
    "LogManagementList_Confirm_StopBody": "Die Option, die Generierung von Protokollausgaben in die ausgewählten Protokolldateien vorübergehend zu stoppen, sollte nur dann gewählt werden, wenn die entsprechenden Dateien in besonderen Situationen eingefroren werden müssen.",
    "LogManagementList_Confirm_Generic": "Sind Sie sicher, dass Sie fortfahren und die ausgewählte Aktion ausführen möchten?"
}